import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

import { CCard, CCardBody, CCardHeader, CLabel } from "@coreui/react";

import { khoTrungTamApi } from "src/1/apis/kho_trung_tam.api";
import { history } from "src/App";
import { CButton, CInput } from "src/common/components/controls";
import { CCardTitle } from "src/common/components/others";
import { format } from "src/utils/dayjs";
import { useTitle } from "src/utils/hooks/title";

export default function PhieuChamDiemKTT() {
  useTitle("Phiếu chấm điểm KTT");

  //#region Data
  const params = useParams();

  const { data } = useQuery({
    queryKey: ["chi-tiet-phieu-cham-diem-ktt", params?.id],
    queryFn: () => khoTrungTamApi.getById(params.id),
    enabled: !!params.id,
    select: (res) => res?.data?.data,
  });
  //#endregion

  //#region Event
  //#endregion

  //#region Render
  return (
    <>
      <CCard>
        <CCardHeader>
          <CCardTitle>Thông tin chung</CCardTitle>
        </CCardHeader>
        <CCardBody>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div>
              <CLabel>Mã phiếu</CLabel>
              <CInput value={data?.code || ""} disabled />
            </div>
            <div>
              <CLabel>Ngày đánh giá</CLabel>
              <CInput value={format(data?.evaluation_date)} disabled />
            </div>
            <div>
              <CLabel>Số kỳ đánh giá</CLabel>
              <CInput value={data?.cycle || ""} disabled />
            </div>
            <div>
              <CLabel>Năm</CLabel>
              <CInput value={data?.year || ""} disabled />
            </div>
            <div>
              <CLabel>Ghi chú</CLabel>
              <CInput value={data?.note || ""} disabled />
            </div>
            <div>
              <CLabel>Chi nhánh đánh giá</CLabel>
              <CInput
                value={`${data?.submitted_stores} / ${data?.total_stores}`}
                disabled
              />
            </div>
          </div>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader className="flex flex-row items-center justify-between">
          <CCardTitle>Điểm trung bình</CCardTitle>
          <CButton
            onClick={() => history.push(`/central/rating/${params?.id}`)}
          >
            Chấm điểm
          </CButton>
        </CCardHeader>
        <CCardBody>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {(data?.average_scores || []).map((e) => (
              <div key={e.criterion_code}>
                <CLabel>{e.criterion_label}</CLabel>
                <CInput value={e?.average_score || ""} disabled />
              </div>
            ))}
          </div>
        </CCardBody>
      </CCard>
    </>
  );
  //#endregion
}
